import React, { PropTypes, Component } from 'react';

class Input extends Component {

  onClick() {
    if (this.props.onClick) this.props.onClick();
  }

  render() {
    const error = this.props.error ? <div className="error-message">{this.props.error}</div> : undefined;
    return (
      <div className="input-container">
        <input {...this.props} />
        {error}
      </div>
    );
  }
}

Input.propTypes = {
  error: PropTypes.string,
  onClick: PropTypes.func,
};

export default Input;



// WEBPACK FOOTER //
// ./src/app/components/input.jsx